var map = {
	"./icon1.jpg": "edb4",
	"./icon2.jpg": "68a4",
	"./icon3.jpg": "7819",
	"./icon4.jpg": "88ac",
	"./icon5.jpg": "f1e8",
	"./icon6.jpg": "5709"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "33f2";